import type { PropsWithChildren } from "react";
import { IoChevronForward } from "react-icons/io5";
import { Link } from "react-router";

import type { Account as AccountType } from "shared/api/use-connected-accounts-query";

import AppleIcon from "shared/assets/svgs/apple.svg?react";
import GoogleIcon from "shared/assets/svgs/google-icon.svg?react";
import { Button } from "shared/ui/button";
import { cn } from "shared/utils/cn";

type Props = {
  className?: string;
  account: AccountType;
};

export const Account = (props: PropsWithChildren<Props>) => {
  const { className, account } = props;

  return (
    <Link className="outline-hidden" to={`/account/${account.name}`}>
      <div
        className={cn(
          "border-dark-grey flex items-center gap-x-3 rounded-xl border px-4 py-3",
          account.is_outdated && "border-pale-red bg-pale-red/12",

          className
        )}
      >
        {account.type === "icloud" ? (
          <AppleIcon className="size-6 shrink-0 [&_path]:fill-white" />
        ) : (
          <GoogleIcon className="size-6 shrink-0" />
        )}
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="min-w-0 overflow-hidden text-lg leading-5.5 tracking-[0.4px] whitespace-nowrap text-white [mask-image:linear-gradient(to_right,black_calc(100%-28px),transparent)]">
            {account.name}
          </div>
          {account.is_outdated && (
            <div className="flex flex-col items-start gap-y-3">
              <span className="text-pale-red mt-0.5 text-sm leading-6 tracking-[0.23px]">
                This account is outdated
              </span>

              <Button size="34" theme="white">
                Reconnect
              </Button>
            </div>
          )}
        </div>
        <IoChevronForward className="shrink-0" />
      </div>
    </Link>
  );
};
